import React from "react";
import PropTypes from "prop-types";

import { Wrapper } from "./styles";

const GridBoard = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

GridBoard.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

GridBoard.defaultProps = {
  children: null,
};

export default GridBoard;
